import { atom } from 'recoil'

const estate_detail_news_btn_click_atom = atom<boolean>({
  key: '@estate/detail-news-btn-click-atom',
  default: false,
})

export default estate_detail_news_btn_click_atom
